import { call, put, takeEvery } from 'redux-saga/effects';
import { getWebJobs } from '../../../Price-o-matic/requests/get_web_jobs_request';
import { getWebJobsRequestSuccess, getWebJobsRequestFailure } from '../actions/get_web_jobs.actions';
import { GET_LEADOM_WEB_JOBS_REQUEST } from '../constants/web_jobs.constants';

function* getWebJobRequest() {
    const web_jobs = yield call(getWebJobs); const
        { result, options } = web_jobs;
    result
        ? yield put(getWebJobsRequestSuccess(options))
        : yield put(getWebJobsRequestFailure('Something gone wrong!'));
}

export default function* getLeadOMWebJobsSaga() {
    yield takeEvery(GET_LEADOM_WEB_JOBS_REQUEST, getWebJobRequest);
}



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Lead-o-matic/redux/sagas/get_web_jobs.saga.js